/* eslint-disable react/no-find-dom-node */
/* eslint-disable class-methods-use-this */
import ReactDOM from 'react-dom';

class LazyRegistry {
  registry = Object.create(null, {});
  id = 0;
  isEventHandlerRegistered = false;

  constructor() {
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  register(component, callback) {
    if (!this.isEventHandlerRegistered) {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('orientationchange', this.handleResize);
    }

    this.id = this.id + 1;
    const element = ReactDOM.findDOMNode(component);
    const rectangle = this.measureElement(element);
    const isVisible = this.getIsRectangleInViewport(rectangle);

    this.registry[this.id] = {
      component,
      callback,
      rectangle,
      isVisible,
    };

    callback(isVisible);

    return this.id;
  }

  unregister(id) {
    this.registry[id] = undefined;
  }

  refresh() {
    Object.keys(this.registry).forEach((id) => {
      const item = this.registry[id];

      if (item) {
        const element = ReactDOM.findDOMNode(item.component);
        item.rectangle = this.measureElement(element);
      }
    });

    this.updateVisibility();
  }

  updateVisibility() {
    Object.keys(this.registry).forEach((id) => {
      const item = this.registry[id];
      if (item && item.callback) {
        const isVisible = this.getIsRectangleInViewport(item.rectangle);

        if (isVisible !== item.isVisible) {
          item.isVisible = isVisible;
          item.callback(isVisible);

          if (isVisible === true) {
            this.unregister(id);
          }
        }
      }
    });
  }

  measureElement(element) {
    // Must copy props out because we can't use Object rest spread
    const rect = element.getBoundingClientRect();
    const { width, height } = rect;
    let { top, right, bottom, left } = rect;
    const { scrollY, scrollX } = window;

    if (scrollY > 0) {
      top += scrollY;
      bottom += scrollY;
    }

    if (scrollX > 0) {
      left += scrollX;
      right += scrollX;
    }

    return { width, height, top, right, bottom, left };
  }

  getIsRectangleInViewport(rectangle) {
    const {
      innerHeight,
      innerWidth,
      scrollY,
      scrollX,
    } = window;

    return (
      rectangle.top - 100 <= scrollY + innerHeight &&
      rectangle.left - 100 <= scrollX + innerWidth
    );
  }

  handleScroll(event) {
    this.updateVisibility();
  }

  handleResize(event) {
    this.refresh();
  }
}

export default new LazyRegistry();



// WEBPACK FOOTER //
// ./application/js/lib/lazy.js